import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

// Seus hooks existentes (Mantidos intactos!)
import { useGameCatalogue } from '../hooks/useGameCatalogue'; 
import { useInfiniteScroll } from '../hooks/useInfiniteScroll';

// O seu componente de busca atual e os novos componentes V2
import SearchBar from '../components/SearchBar';
import GameListV2 from '../components/GameListV2';
import GameDetailModalV2 from '../components/GameModalV2';

import Config from "../Config.json";
import ICON from "../assets/icons/favicon.ico";

const TITLE = Config.SITE_TITLE + " - Acervo Completo";
const DESC = "Explorando a biblioteca completa da Deli da Persy";
const CANONICAL = Config.SITE_DOMAIN + "/biblioteca/acervo";

function GameCatalogueV2() {
    const navigate = useNavigate();
    const {
        games,
        isLoading,
        isFetchingMore,
        hasNextPage,
        searchParams,
        handleSearchChange,
        loadMoreGames
    } = useGameCatalogue();

    const [selectedGameId, setSelectedGameId] = useState(null);

    // O seu hook original funcionando perfeitamente com a nova UI
    useInfiniteScroll(
        loadMoreGames, 
        isLoading,
        isFetchingMore,
        hasNextPage
    );

    return (
        <div className="min-h-screen bg-[#FFF5EE] pt-24 pb-24 relative overflow-hidden">
            {/* SEO & Meta */}
            <title>{TITLE}</title>
            <link rel="icon" href={ICON} />
            <link rel="canonical" href={CANONICAL} />
            <meta name="description" content={DESC} />

            {/* Textura de papel vintage (Opcional, super leve) */}
            <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/aged-paper.png')]" />
            
            <div className="max-w-7xl mx-auto px-6 relative z-10">
                
                {/* --- HEADER DA PÁGINA --- */}
                <div className="mb-10 pt-8">
                    <button 
                        onClick={() => navigate('/biblioteca')}
                        className="group flex items-center gap-2 text-[#528a89] hover:text-[#971253] transition-colors font-serif italic mb-6"
                    >
                        <ChevronLeft size={18} className="group-hover:-translate-x-1 transition-transform" /> 
                        Voltar ao Menu de Destaques
                    </button>
                    
                    <h1 className="font-serif text-5xl md:text-6xl text-[#971253] mb-4">
                        O Grande Acervo
                    </h1>
                    <div className="h-[2px] w-24 bg-[#dbcdac] mb-6" />
                    <p className="text-stone-600 text-lg font-light max-w-2xl">
                        Explore nossa biblioteca completa. Filtre por número de jogadores ou duração para encontrar o desafio perfeito para a sua trupe.
                    </p>
                </div>

                {/* --- BARRA DE BUSCA --- */}
                {/* Envolvemos o seu SearchBar atual num container com estilo de vidro/editorial */}
                <div className="mb-12 bg-white/60 p-6 md:p-8 rounded-2xl border border-[#dbcdac]/40 shadow-sm backdrop-blur-sm">
                    <SearchBar 
                        initialParams={searchParams} 
                        onSearch={handleSearchChange} 
                    />
                </div>
                
                {/* --- LISTA DE JOGOS V2 --- */}
                <GameListV2 
                    games={games} 
                    isLoading={isLoading} 
                    isFetchingMore={isFetchingMore}
                    hasNextPage={hasNextPage}
                    onGameClick={(id) => setSelectedGameId(id)}
                />

                {/* --- MODAL DE DETALHES V2 --- */}
                {selectedGameId && (
                    <GameDetailModalV2 
                        gameId={selectedGameId} 
                        onClose={() => setSelectedGameId(null)} 
                    />
                )}
            </div>
        </div>
    );
}

export default GameCatalogueV2;